import { createSlice, current } from "@reduxjs/toolkit";

const initialState: any = {
  alerts: [],
};

export const apiAlert = createSlice({
  name: "apiAlert",
  initialState,
  reducers: {
    updateApiAlert: (state, action) => {
      const currentState = current(state);

      const currentAlerts = currentState.alerts;
      const filteredAlerts = currentAlerts?.filter((item: any) => {
        return item.id !== action.payload;
      });
      state.alerts = filteredAlerts;
    },
    setApiAlert: (state, action) => {
      state.alerts = [...state.alerts, ...action.payload.alerts];
    },
  },
});

export const { setApiAlert, updateApiAlert } = apiAlert.actions;

export default apiAlert.reducer;
